import { setSessionStore, removeSessionStore } from '@/utils/storage'
import { MENUS, MENU_BUTTONS } from '@/store/mutation-types'
//表单审批组件相关状态数据
const approval = {
    namespaced: true,
    state: {
        vacationRules: [],
        processInstanceId: null,
    },
    getters: {
        getVacationRules() {
            return state.vacationRules;
        },
        getProcessInstanceId() {
            return state.processInstanceId;
        }
    },
    mutations: {
        setVacationRules(state, payload) {
            let rules = [];
            try {
                if (typeof payload === 'string' && payload) {
                    rules = JSON.parse(payload) || {};
                } else {
                    rules = payload;
                }
            } catch (error) {
                console.error('解析假期规则信息失败：', error);
                rules = [];
            }
            state.vacationRules = rules
        },
        setProcessInstanceId(status, payload) {
            status.processInstanceId = payload.instanceId
        },
    },

    actions: {

    }
}

export default approval
